// extracted by mini-css-extract-plugin
export default {"MemeGenerator":"LCwT2urI4Ymyhz6aPWrr"};